<template>
  <div class="container-fluid">
    <div class="row" v-if="possibleItems.list.width && Object.keys(possibleItems.list.width).length > 0">
      <div class="col-12">
        <h4>{{ $t('Menu.list.widths.width') }}</h4>
      </div>
    </div>
    <div class="row border-bottom" v-if="possibleItems.list.width && Object.keys(possibleItems.list.width).length > 0">
      <div class="col-4 text-start">
        <img :src="appUrl + '/img/assets/widths/breite.jpg'" :srcset="appUrl + '/img/assets/widths/breite@2x.jpg'">
      </div>
      <div class="col-8">
        <select class="form-control" @change="changeItem('width', $event.target.value)" v-if="typeof possibleItems.list == 'object'">
          <option v-for="(item, index) in possibleItems.list.width" v-bind:key="index" :selected="item.match" :value="index">{{ item.text }} mm</option>
        </select>
      </div>
      <div class="col-12">
        <div class="form-group">
          <div class="checkbox">
            <label class="checkbox-inline">
              <input type="checkbox" v-model="fitStone" @change="fitStoneWithWidth()" checked/>&nbsp;
              <span>{{ $t('Menu.list.widths.fitStone') }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h4>{{ $t('Menu.list.widths.height') }}</h4>
      </div>
    </div>
    <div class="row border-bottom">
      <div class="col-4">
        <img :src="appUrl + '/img/assets/widths/hoehe.jpg'" :srcset="appUrl + '/img/assets/widths/hoehe@2x.jpg'">
      </div>
      <div class="col-8">
        <select class="form-control" @change="changeItem('height', $event.target.value)" v-if="typeof possibleItems.list == 'object'">
          <option v-for="(item, index) in possibleItems.list.height" v-bind:key="index" :selected="item.match" :value="index">{{ item.text }} mm</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
  import Config from "@/vuex/Config";

  export default {
    name: 'VariationsWidths',
    props: [
      'possibleItems'
    ],
    data() {
      return {
        appUrl: Config.getters.getAppUrl,
        fitStone: Config.getters.getFitStoneWithWidth
      }
    },
    methods: {
      changeItem: function (type, id) {
        if (type === 'height') {
          let item = this.possibleItems.list[type][id];
          this.$parent.$parent.changeItem(item.itemnumber, item.alerts);
        } else {
          this.$parent.$parent.changeItemByVarValue(id + ((this.fitStone === true) ? '_1' : ''));
        }
      },
      fitStoneWithWidth: function() {
          Config.commit('setFitStoneWithWidth', this.fitStone);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #app {
    h4 {
      font-weight: bold;
      font-size: 1em;
      margin-bottom: 1.5em;
    }

    .border-bottom {
      padding-bottom: 1em;
      margin-bottom: 1em;
      border-bottom: solid 0.1em $borderColor;
    }

    select {
      margin-top: 1.4em;
    }

    .checkbox {
      margin-top: 1.5rem;
      padding: 1rem;
      background-color: $lightGreyBg;
    }

    img {
      display: block;
      width: 5em;
      height: 5em;
      border-radius: 5em;
      border: solid 0.1rem $brandDarkGrey;
      margin-bottom: 0.5em;
    }
  }
</style>
